import React from 'react';
import pretty from 'pretty';

import { useState, useEffect, useRef, useMemo } from 'react';
import ReactDOMServer from 'react-dom/server';
import { useDispatch, useSelector } from 'react-redux';
import CodeMirror from 'rodemirror';
import { oneDark } from '@codemirror/theme-one-dark';
import { html as htmlLang } from '@codemirror/lang-html';
import FieldModal from './field_modal';
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2
} from 'react-html-parser';
import {
  downloadPdf,
  updatePdfTemplateRequest,
  pdfTemplateFieldRequested,
  clearPdfField
} from './redux/actions/pdfTemplateActions';
import { downloadPdfJson } from '../shared/pdf_field_utils';
import PdfModal from './pdf_modal';

export default function HtmlPage(props) {
  const [html, setHtml] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [element, setElement] = useState(null);
  const [field, setField] = useState(null);
  const [fieldWidth, setFieldWidth] = useState(null);
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [activeTab, setActiveTab] = useState('annotate');
  const [editorHtml, setEditorHtml] = useState(props.htmlTemplate || '');
  const [editorView, setEditorView] = useState(null);

  const pdfTemplate = useSelector((state) => state.pdfTemplates.pdfTemplate);
  const pdfFields = useSelector((state) => state.pdfTemplates.pdfFields);
  const pdfField = useSelector((state) => state.pdfTemplates.pdfField);
  const rawPdf = useSelector((state) => state.pdfTemplates.rawPdf);
  const htmlContainer = useRef();
  const dispatch = useDispatch();

  const editorExtensions = useMemo(() => [oneDark, htmlLang()], []);

  useEffect(() => {
    setHtml(
      parseHtmlTemplate(pdfTemplate?.html_template ?? props.htmlTemplate)
    );
  }, [pdfTemplate?.html_template]);

  useEffect(() => {
    const current = pdfTemplate?.html_template ?? props.htmlTemplate ?? '';
    if (editorView && editorView.state.doc.toString() !== current) {
      editorView.dispatch({
        changes: {
          from: 0,
          to: editorView.state.doc.length,
          insert: current
        }
      });
    }
    setEditorHtml(current);
  }, [pdfTemplate?.html_template, editorView]);

  useEffect(() => {
    if (pdfField) {
      setShowModal(true);
    }
  }, [pdfField]);

  const prevElement = useRef();

  useEffect(() => {
    prevElement.current = element;

    if (element) {
      element.classList.add('active_field');
    }
  }, [element]);

  function findFieldOrContainer(element) {
    while (element) {
      if (
        element.classList.contains('new_field') ||
        element.classList.contains('field') ||
        element.classList.contains('field_container') ||
        element.classList.contains('ignored')
      ) {
        return element;
      }
      element = element.parentElement;
    }
    return null;
  }

  const handleClick = (e) => {
    let htmlElement = findFieldOrContainer(e.target);
    console.log(e.target);

    if (htmlElement === null || htmlElement === undefined) {
      resetField();
      if (prevElement.current) {
        prevElement.current.classList.remove('active_field');
      }
      console.log('Nothing clicked');
      return;
    }

    if (htmlElement.className === 'new_field') {
      if (htmlElement.size) {
        setFieldWidth(htmlElement.size);
      } else {
        setFieldWidth(htmlElement.style['min-width']);
      }

      setElement(htmlElement);
      setShowModal(true);
      setField(null);
      // dispatch(clearPdfField()); // Can we remove this?
      if (prevElement.current) {
        prevElement.current.classList.remove('active_field');
      }

      console.log('clicked new_field');
    } else if (
      htmlElement.classList.contains('field') ||
      htmlElement.classList.contains('field_container')
    ) {
      let pdfFieldId = null;
      let htmlField = null;
      let width = htmlElement.size
        ? htmlElement.size
        : htmlElement.style['min-width'];

      console.log('clicked field');

      // Find the id in the element, parent or grandparent

      if (htmlElement.tagName === 'INPUT' && htmlElement.name) {
        htmlField = htmlElement;
        pdfFieldId = htmlElement.name;
      } else if (htmlElement.id) {
        htmlField = htmlElement;
        pdfFieldId = htmlElement.id;
      } else if (htmlElement.parentNode.id) {
        htmlField = htmlElement.parentNode;
        pdfFieldId = htmlElement.parentNode.id;
      } else if (htmlElement.parentNode.parentNode.id) {
        htmlField = htmlElement.parentNode.parentNode;
        pdfFieldId = htmlElement.parentNode.parentNode.id;
      }

      if (pdfFieldId) {
        setElement(htmlField);
        setField(htmlField);
        setFieldWidth(width);

        //lookup field id by the external_id
        let foundField = pdfFields.find(
          (field) => field.external_id == pdfFieldId
        );

        dispatch(pdfTemplateFieldRequested(pdfTemplate.id, foundField.id));
        if (prevElement.current) {
          prevElement.current.classList.remove('active_field');
        }
      }
    } else if (e.target.className === 'ignored') {
      if (prevElement.current) {
        prevElement.current.classList.remove('active_field');
      }
      resetField();
      console.log('clicked ignored');
    }
  };

  const parseHtmlTemplate = (htmlTemplate) => {
    let parsedHtml = ReactHtmlParser(htmlTemplate, {
      transform: (node, index) => {
        // find fields not annotated yet
        if (
          node.name === 'span' &&
          node.attribs.style &&
          node.attribs.style.includes('min-width')
        ) {
          // check parent nodes if this is an existing field (span.field_container) or new field
          if (
            (node.parent.attribs.class &&
              node.parent.attribs.class.includes('field_container')) ||
            (node.parent.parent.attribs.class &&
              node.parent.parent.attribs.class.includes('field_container'))
          ) {
            console.log('existing field found');
          } else {
            node.attribs.class = 'new_field';
            console.log('Found field: ');
            console.log(node);
          }
        }

        if (node.name === 'input') {
          if (node.attribs.name) {
            console.log('Found signature field');
          } else {
            node.attribs.class = 'new_field';
          }
        }
      }
    });
    return parsedHtml;
  };

  const currentHtmlString = () => {
    if (activeTab === 'editHtml') {
      return editorView ? editorView.state.doc.toString() : editorHtml;
    }
    let innerHTML = htmlContainer.current.innerHTML;
    innerHTML = innerHTML.replace(/\s*active_field\s*/g, '');
    return pretty(innerHTML, { ocd: true });
  };

  const saveTemplate = (onSaved) => {
    const htmlString = currentHtmlString();
    dispatch(
      updatePdfTemplateRequest(pdfTemplate.id, htmlString, () => {
        setUnsavedChanges(false);
        window.alert('Saved');
        if (onSaved) onSaved();
      })
    );
  };

  const switchTab = (nextTab) => {
    if (nextTab === activeTab) return;

    if (unsavedChanges) {
      const proceed = window.confirm(
        'You have unsaved changes that will be discarded if you switch tabs. Continue?'
      );
      if (!proceed) return;

      const current = pdfTemplate?.html_template ?? props.htmlTemplate ?? '';
      setHtml(parseHtmlTemplate(current));
      if (editorView && editorView.state.doc.toString() !== current) {
        editorView.dispatch({
          changes: {
            from: 0,
            to: editorView.state.doc.length,
            insert: current
          }
        });
      }
      setEditorHtml(current);
      setUnsavedChanges(false);
    }

    setActiveTab(nextTab);
  };

  const tabButtonStyle = (tab) => ({
    fontWeight: activeTab === tab ? 'bold' : 'normal',
    textDecoration: activeTab === tab ? 'underline' : 'none',
    marginRight: '4px'
  });

  const toolbar = () => {
    return (
      <div id="top-box" style={{ zIndex: 1000 }}>
        <button
          onClick={() => switchTab('annotate')}
          style={tabButtonStyle('annotate')}
        >
          Annotate
        </button>
        <button
          onClick={() => switchTab('editHtml')}
          style={tabButtonStyle('editHtml')}
        >
          Edit HTML
        </button>
        <span style={{ display: 'inline-block', width: '12px' }} />
        {activeTab === 'editHtml' ? (
          <button onClick={() => saveTemplate()} disabled={!unsavedChanges}>
            Save HTML
          </button>
        ) : (
          <button onClick={() => saveTemplate()} disabled={!unsavedChanges}>
            Save PdfTemplate
          </button>
        )}
        <button
          onClick={() => {
            setShowPdfModal(true);
            dispatch(
              downloadPdf(downloadPdfJson(pdfTemplate, pdfFields, true))
            );
          }}
        >
          Generate Test PDF
        </button>
        <button
          onClick={() => {
            setShowPdfModal(true);
            dispatch(
              downloadPdf(downloadPdfJson(pdfTemplate, pdfFields, false))
            );
          }}
        >
          Generate Test PDF (With Test Data)
        </button>
        <button
          onClick={(e) => {
            props.close();
            e.preventDefault();
          }}
        >
          Close
        </button>
      </div>
    );
  };

  const resetField = () => {
    setElement(null);
    setField(null);
    setShowModal(false);
  };

  const replaceElement = (replace) => {
    let template = document.createElement('template');
    replace = replace.trim();
    template.innerHTML = replace;
    element.parentElement.replaceChild(template.content.firstChild, element);
    setUnsavedChanges(true);
  };

  return (
    <div style={{ display: 'flex' }}>
      {showPdfModal ? (
        <PdfModal
          close={() => {
            setShowPdfModal(false);
          }}
          rawPdf={rawPdf}
          style={{
            position: 'absolute',
            zIndex: 10001,
            top: 0,
            left: 0,
            height: '100%',
            width: '100%',
            backgroundColor: '#FFF'
          }}
        />
      ) : null}
      {activeTab === 'annotate' ? (
        <FieldModal
          close={resetField}
          replace={replaceElement}
          field={field}
          fieldWidth={fieldWidth}
          style={{
            zIndex: 10000,
            height: '100%',
            width: '30%',
            overflow: 'scroll'
          }}
        />
      ) : null}
      <div
        id="right-column"
        style={activeTab === 'editHtml' ? { marginLeft: 0 } : undefined}
      >
        {toolbar()}
        <div
          onClick={handleClick}
          ref={htmlContainer}
          style={{ display: activeTab === 'annotate' ? 'block' : 'none' }}
        >
          {html}
        </div>
        {activeTab === 'editHtml' ? (
          <div style={{ marginTop: '50px', height: 'calc(100vh - 100px)' }}>
            <CodeMirror
              extensions={editorExtensions}
              value={editorHtml}
              onUpdate={(update) => {
                if (update.docChanged) {
                  setUnsavedChanges(true);
                }
              }}
              onEditorViewChange={(view) => setEditorView(view)}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
}
